import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { BusinessPlanSurveySectionGuidanceKey } from './types';

export const businessPlanSlice: Slice<{
  sections: Partial<Record<BusinessPlanSurveySectionGuidanceKey, string>>;
}> = createSlice({
  name: 'businessPlan',
  initialState: {
    sections: {},
  },
  reducers: {
    resetBusinessPlan: (state) => {
      state.sections = {};
    },
    setSectionText: (
      state,
      {
        payload: { key, text },
      }: PayloadAction<{ key: BusinessPlanSurveySectionGuidanceKey; text: string }>
    ) => {
      state.sections[key] = text;
    },
  },
});

export const { setSectionText, resetBusinessPlan } = businessPlanSlice.actions;

export const businessPlanReducer = businessPlanSlice.reducer;
